import React, { useState } from "react"
import { investment } from "../investmentData"
import { Input } from "reactstrap";

import { useNavigate } from "react-router-dom"

const InvestmentPlan = ({ planRef }) => {
    const [selectedPlan, setSelectedPlan] = useState("1")
    const navigate = useNavigate()
    return (
        <div className="mb-5" ref={planRef}>
            <div className="investment-plan-title text-center"><h1>Our Plans</h1></div>
            <div className="investment-plan-tab display-lap">
                {investment.map(i => (
                    <button key={i.id}
                        onClick={() => { setSelectedPlan(i.id) }}
                        className={i.id === selectedPlan ? "active-investment-plan-tab" : "inactive-investment-plan-tab"}
                    >
                        {i.name}
                    </button>))}
            </div>
            <div className="display-phone display-phone phone-inv-form">
                <Input className="form-control rounded-0 shadow-none phone-inv-form-input" type="select" name="select" id="exampleSelect" value={selectedPlan} onChange={e => setSelectedPlan(e.target.value)}>
                    {investment.map(i => <option key={i.id} value={i.id}>{i.name}</option>)}
                </Input>
            </div>


            <div className="investment-plan-container">
                {
                    investment.map(i => (
                        <div key={i.id} className={i.id === selectedPlan ? "display-investment" : "no-display-investment"}>
                            <div className="investment-text">
                                <p> {i.about}</p>
                                <button className="select-plan-btn display-lap2" onClick={() => navigate("/application-form", { state: { selectedPlan: i.id } })}>Select Plan</button>
                            </div>
                            <div className="investment-img">
                                <img src={i.image} style={{ width: i.style.width }} alt="img" />
                            </div>
                        </div>
                    ))
                }
                <div className="select-plan-btn-div display-phone3"><button className="select-plan-btn" onClick={() => navigate("/application-form")}>Select Plan</button> </div>
                {/* <button className="read-more-btn btn" onClick={() => navigate("/investment-detail", {state: {selectedPlan}})}>Read More</button></div>*/}
            </div>
            <div className="investment-indicator-container">
                {investment.map(i => (
                    <div key={i.id} className={i.id === selectedPlan ? "active-investment-indicator" : "investment-indicator"}></div>
                ))}
            </div>
        </div>
    )
}

export default InvestmentPlan